module.exports = __webpack_public_path__ + "img/lucky_600.13a80c03.png";